/**
 * @file Compact Primitive Editor for grid cells (no label, minimal layout)
 * @version 2.0.0
 */

import PrimitiveEditor, { CONTROLS_TEMPLATE } from './PrimitiveEditor.js';

export default {
  name: 'CompactPrimitiveEditor',
  extends: PrimitiveEditor,

  setup(props, ctx) {
    return PrimitiveEditor.setup(props, ctx);
  },

  template: `
  <template v-if="currentMode !== 'hidden'">

    <!-- Value cell -->
    <div class="d-flex gap-2">
      <!-- Undefined value -->
      <span v-if="isUndefined" class="text-muted fst-italic flex-grow-1">—</span>

      <!-- Display mode -->
      <template v-else-if="currentMode === 'display'">
        <component
          :is="displayComponent"
          :value="internalValue.editable"
          :getAttribute="getAttribute"
          :class="valueTextClass"
          class="flex-grow-1"
        />
      </template>

      <!-- Edit mode -->
      <template v-else>
        <component
          ref="input"
          :is="editComponent"
          :value="internalValue.editable"
          :getAttribute="getAttribute"
          :validationError="validationError"
          :fieldId="fieldId"
          :class="valueTextClass"
          @input="handleInput"
          @keydown="handleKeydown"
          @blur="handleBlur"
        />
      </template>

      <!-- Controls (for grid layout) -->
      <div class="d-flex gap-1 align-items-center" :style="controlStyles">
        ${CONTROLS_TEMPLATE}
      </div>
    </div>
  </template>
  `,
};
